// src/components/initiatives/InitiativeFocus.jsx
import { motion } from "framer-motion";
import {
  FileText, LayoutDashboard, SearchCheck, GraduationCap, ShieldCheck, BarChart3
} from "lucide-react";

const initiativeCards = [
  {
    title: "Policy & Research",
    icon: FileText,
    description:
      "Ground research, agenda setting, policy formation, monitoring and evaluation for impactful implementation.",
  },
  {
    title: "Program Design",
    icon: LayoutDashboard,
    description:
      "Strategic planning, CSR project design, due diligence, monitoring, and effective implementation support.",
  },
  {
    title: "Social Assessment",
    icon: SearchCheck,
    description:
      "Baseline, mid-term, and impact evaluations, CSR maturity assessment and reporting.",
  },
  {
    title: "Corporate Training",
    icon: GraduationCap,
    description:
      "Need-based training sessions, M&E, people management, team building, and AI for nonprofits.",
  },
  {
    title: "Audit & Evaluation",
    icon: ShieldCheck,
    description:
      "Audits for programs, operations, and M&E systems to strengthen governance and transparency.",
  },
  {
    title: "Data-Driven Impact",
    icon: BarChart3,
    description:
      "Define KPIs, monitor progress, analyze effectiveness, and optimize project outcomes with actionable insights.",
  },
];

const InitiativeFocus = () => {
  return (
    <section className="bg-gradient-to-br from-blue-50 via-white to-purple-50 py-20">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-12">
          Initiative Focus Areas
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {initiativeCards.map((card, index) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.15, duration: 0.6 }}
              className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition hover:-translate-y-2 group"
            >
              <div className="flex justify-center mb-4">
                <card.icon className="h-10 w-10 text-primary group-hover:text-secondary transition" />
              </div>
              <h3 className="text-xl font-semibold text-primary mb-3 font-heading">
                {card.title}
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                {card.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InitiativeFocus;
